<template>
    <div>
        <CommonPopupFrame :changeBottom="0" :changeHeight="70" :isOpen="isOpen" :closeCompleteAction="() => { closeCompleteAction(PROFILE_BOX_LIST.FOOT_WAY, true, false, false) }">
            <div style="width: 36px; height: 5px; background-color: #d9d9d9; margin: 0 auto; border-radius: 5px; margin-top: 5px"></div>
            <div @click="closeCompleteAction(PROFILE_BOX_LIST.FOOT_WAY, true, false, false)" style="padding-left: 12px; margin-top: 6px; font-weight: 700; color: #808080; height: 30px; width: 50px;">닫기</div>
            <div @touchmove.stop="() => { }" style="margin-top: 31px; flex: 1; overflow-y: scroll; padding: 0 12px; padding-bottom: 20px;">
                <div style="text-align: center;">
                    <div style="font-weight: 700; font-size: 32px; line-height: 46px;">주로 사용하는 발</div>
                    <div style="margin-top: 15px; font-weight: 500; line-height: 24px;">자주 사용하는 발을 선택하세요</div>
                    <div style="display: flex; justify-content: center; gap: 65px; margin-top: 40px;">
                        <div @click="setFootWay(PROFILE_FOOT_WAY.LEFT)">
                            <div style="margin-bottom: 18px; color: var(--color-main); font-weight: 500">왼발</div>
                            <img style="width: 90px;" :src="leftFoot ? require('@/assets/images/mypage/left-foot-on.png') : require('@/assets/images/mypage/left-foot.png')" alt="">
                        </div>
                        <div @click="setFootWay(PROFILE_FOOT_WAY.RIGHT)">
                            <div style="margin-bottom: 18px; color: var(--color-main); font-weight: 500">오른발</div>
                            <img style="width: 90px;" :src="rightFoot ? require('@/assets/images/mypage/right-foot-on.png') : require('@/assets/images/mypage/right-foot.png')" alt="">
                        </div>
                    </div>
                </div>
            </div>
            <div style="height: 90px; padding: 0 12px;">
                <div @click="save" v-if="footWay !== ''" class="save_btn_active">저장하기</div>
                <div v-else class="save_btn_unactive">저장하기</div>
            </div>
        </CommonPopupFrame>
    </div>
</template>

<script>
import CommonPopupFrame from '@/components/modal/my/CommonPopupFrame'
import ResponseCode from '../../ResponseCode';
import { PROFILE_FOOT_WAY, PROFILE_BOX_LIST } from '@/Constants'

export default {
    name: 'SettingFootWay',
    components: { CommonPopupFrame },
    props: {
        isOpen: {
            type: Boolean,
            default: false,
        },
        closeCompleteAction: {
            type: Function,
            default: () => { },
        },
    },
    data() {
        return {
            footWay: '',
            PROFILE_FOOT_WAY: PROFILE_FOOT_WAY,
            PROFILE_BOX_LIST: PROFILE_BOX_LIST,
            leftFoot: false,
            rightFoot: false,
        }
    },
    methods: {
        setFootWay(footWay) {
            if (footWay === PROFILE_FOOT_WAY.LEFT) {
                this.leftFoot = !this.leftFoot
            }

            if (footWay === PROFILE_FOOT_WAY.RIGHT) {
                this.rightFoot = !this.rightFoot
            }

            if (this.leftFoot && this.rightFoot) {
                this.footWay = PROFILE_FOOT_WAY.BOTH
            } else if (this.leftFoot) {
                this.footWay = PROFILE_FOOT_WAY.LEFT
            } else {
                this.footWay = PROFILE_FOOT_WAY.RIGHT
            }

            if (!this.rightFoot && !this.leftFoot) {
                this.footWay = ''
            }
        },
        async save() {
            this.$GlobalStore.showProgress()

            const formData = new FormData()
            formData.append('foot_way', this.footWay)

            const res = await this.$Axios.post('/api/profile/save', formData, { headers: { 'Content-Type': 'multipart/form-data' } });

            if (res.data.code === ResponseCode.SUCCESS) {
                this.footWay = ''
                this.leftFoot = false
                this.rightFoot = false
                this.$GlobalStore.hideProgress()
                this.$GlobalStore.setLoginInfo(res.data.loginInfo)
                this.closeCompleteAction(PROFILE_BOX_LIST.FOOT_WAY, true, false, true)
            }
        }
    },
    watch: {
        isOpen(newVal) {
            if (!newVal) {
                this.footWay = ''
                this.rightFoot = false
                this.leftFoot = false
            }
        }
    },
    created() {
        this.save = this.$Once(this.save)
    }
}
</script>

<style scoped>
.common_box {
    padding: 10px;
    border-radius: 12px;
    background-color: #f5f5f5;
    margin-top: 40px;
}

.save_btn_active {
    height: 48px;
    line-height: 48px;
    border-radius: 12px;
    background-color: #210f03;
    text-align: center;
    color: #fff;
    font-size: 14px;
    font-weight: 500;
    margin-top: 12px;
}

.save_btn_unactive {
    height: 48px;
    line-height: 48px;
    border-radius: 12px;
    background-color: #f5f5f5;
    text-align: center;
    color: #d9d9d9;
    font-size: 14px;
    font-weight: 500;
    margin-top: 12px;
}

.active {
    background-color: #210f03;
    color: #fff;
}
</style>